<template>
  <div
    class="tw:rounded-xl tw:border tw:w-full tw:p-4 tw:flex tw:flex-col"
    :class="isActive ? 'tw:bg-white tw:border-gray-300 ' : 'tw:bg-blue-100 tw:border-blue-700'"
  >
    <div class="tw:flex tw:justify-between">
      <img :src="icon" :alt="$t(title)" class="tw:mb-3 tw:max-h-6 tw:max-w-6" />
      <p v-if="isActive" class="tw:font-bold tw:text-green-700">{{ $t(activeTranslations) }}</p>
    </div>
    <div class="tw:flex tw:flex-col tw:pb-4 tw:mb-4 tw:border-b tw:border-gray-300 tw:flex-1">
      <h1 class="tw:text-xl tw:font-bold">{{ $t(title) }}</h1>
      <p>{{ $t(text) }}</p>
    </div>

    <a
      v-if="id === 'dedicated_support'"
      target="_blank"
      @click="logEvent"
      rel="noopener noreferrer"
      :href="contactUsUrl"
      class="tw:text-blue-700 tw:font-bold"
    >
      {{ $t(buttonLabel) }}
    </a>
    <router-link v-else @click="logEvent" :to="route" class="tw:text-blue-700 tw:font-bold">{{
      $t(buttonLabel)
    }}</router-link>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import { getContactUrl } from '@/utils/Utility.ts'
import { selectedAccommodationId } from '@/layouts/queries'
import { useSessionValues } from '@/composables/useSessionValues'

import appAnalytics from '@/utils/tracking'

const { language, userId } = useSessionValues()
const props = defineProps({
  id: String,
  title: String,
  text: String,
  buttonLabel: String,
  icon: URL,
  isActive: Boolean,
  route: Object,
})

const contactUsUrl = computed(() =>
  selectedAccommodationId.value
    ? getContactUrl(language.value, userId.value, selectedAccommodationId.value, true)
    : null
)

const logEvent = () => {
  if (!selectedAccommodationId.value) return
  appAnalytics.track(appAnalytics.events.SP_PLUS_INSIGHTS_BENEFIT_CARD_CLICKED, {
    item_id: selectedAccommodationId.value,
    benefit_type: props.id,
    benefit_status: props.isActive ? 'active' : 'inactive',
  })
}

const activeTranslations = computed(() => {
  if (props.id === 'contact-badge') return 'contact_badge_active'
  else if (props.id === 'visitors-profile') return 'visitors_profile_active'
  else return 'rate_insights_active'
})
</script>
